// extracted by mini-css-extract-plugin
module.exports = {"img":"HouseManager_img__3FYl9"};